import { PlayerModal } from '@components/chat/PlayerModal';
import { useComplexLeaderboardQuery } from '@http';
import { useTranslation } from 'react-i18next';

export function ComplexInfo() {
  const { t } = useTranslation(undefined, { keyPrefix: 'ComplexInfo' });
  const { data: leaderboard } = useComplexLeaderboardQuery();

  const getTextClass = (index: number) => {
    if (index === 0) return 'text-base slight-active';
    return 'text-base';
  };

  return (
    <>
      {/* Info */}
      <div className="p-2 relative border-b border-secondary bg-black/40 lootinfo">
        <div className="absolute inset-0 grid-overlay" />
        <div className="flex flex-col justify-between text-left h-full w-full relative">
          <p className="text-lg leading-tight">{t('title')}</p>
          <p className="text-gray-300 text-xs mt-1 pr-8">
            {t('description')}
          </p>
        </div>
      </div>
      {/* Info END */}

      {/* Leaderboard */}
      <div className="p-2 relative border-b border-secondary bg-black/40 lootinfo">
        <div className="flex flex-col justify-between text-left h-full w-full relative">
          <p className="text-lg leading-tight">{t('leaderboard')}</p>
        </div>
      </div>
      {/* Leaderboard END */}

      {leaderboard?.length === 0 && (
        <p className="text-sm text-gray-500 text-center pt-4">
          {t('noLeaderboard')}
        </p>
      )}

      {leaderboard?.map((user, index) => (
        <PlayerModal key={user.id} id={user.id}>
          <div className="p-2 border-b border-secondary bg-black/40">
            <p className={`${getTextClass(index)} leading-tight`}>
              {index + 1}. {user.username}
            </p>
            <p className="text-gray-300 text-xs mt-1 pr-8">
              {t('bestComplex', { best: user.complexBest })}
            </p>
          </div>
        </PlayerModal>
      ))}
    </>
  );
}
